import { c as _c } from "react/compiler-runtime";
import { ProposalCardOutline } from './proposal-card-outline';
interface RoadmapCardProps {
  milestones: number;
  deliverables: number;
}
function RoadmapCard(t0) {
  const $ = _c(13);
  const {
    milestones,
    deliverables
  } = t0;
  let t1;
  if ($[0] !== milestones) {
    t1 = <div className="text-3xl font-bold">{milestones}</div>;
    $[0] = milestones;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="text-foreground/50">Milestones</div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = <div className="flex flex-1 flex-col">{t1}{t2}</div>;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== deliverables) {
    t4 = <div className="text-3xl font-bold">{deliverables}</div>;
    $[5] = deliverables;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="text-foreground/50">Deliverables</div>;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4) {
    t6 = <div className="flex flex-1 flex-col">{t4}{t5}</div>;
    $[8] = t4;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t3 || $[11] !== t6) {
    t7 = <ProposalCardOutline title="Roadmap"><div className="flex gap-2 text-center">{t3}{t6}</div></ProposalCardOutline>;
    $[10] = t3;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
}
export { RoadmapCard };